import React, { useEffect } from "react";
import SafeLocalStorage from "../../utils/SafeLocalStorage";

const CookieyesComponent = () => {
  useEffect(() => {
    const COOKIEYES_LOAD_ATTEMPT_KEY = "cookieyes_load_attempt";

    // Check if script already exists or if there was a previous load attempt
    const existingScript = document.getElementById("cookieyes");
    const previousLoadAttempt = SafeLocalStorage.getItem(COOKIEYES_LOAD_ATTEMPT_KEY);

    // Only proceed if there's no existing script and no previous load attempt
    if (!existingScript && !previousLoadAttempt) {
      try {
        // Mark that we've attempted to load the script
        SafeLocalStorage.setItem(COOKIEYES_LOAD_ATTEMPT_KEY, true);

        const script = document.createElement("script");
        script.id = "cookieyes";
        script.type = "text/javascript";
        // Use environment variable or fallback to the default ID
        const cookieyesId = process.env.GATSBY_COOKIEYES_ID || "27aef9496db261b61ce67093";
        script.src = `https://cdn-cookieyes.com/client_data/${cookieyesId}/script.js`;

        // Add error handling
        script.onerror = (error) => {
          console.error("Failed to load Cookieyes script:", error);
          // We don't remove the load attempt flag on error - we still don't want to try again
        };

        if (document.head) document.head.appendChild(script);
      } catch (error) {
        console.error("Error setting up Cookieyes script:", error);
        // Even if there's an error, we don't want to try again
      }
    }

    return () => {
      const scriptToRemove = document.getElementById("cookieyes");
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
      // We don't remove the load attempt flag on cleanup - we still don't want to try again on remount
    };
  }, []);

  return <></>;
};

export default CookieyesComponent;
